import React from 'react'
import { Modal } from 'reactstrap'
import './index.css'
import coverImg from '../../Assets/img/eventDetails.png'
import QRCode from 'qrcode.react';
import location from '../../Assets/img/location.svg'
import time from '../../Assets/img/ticket_time.svg'
import calendar from '../../Assets/img/tic_cal.svg'
import user from '../../Assets/img/tic_user.svg'
import order from '../../Assets/img/tic_ord.svg'
import copy from '../../Assets/img/tic_cop.svg'
import tag from '../../Assets/img/tic_tag.svg'
import { Row, Col } from 'reactstrap';


const TicketDate = () => {
    function copyToClipboard(text) {
        if (!navigator.clipboard) {
            // Clipboard API not supported, fallback to the old method
            const textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);
            return;
        }

        // Use the Clipboard API
        navigator.clipboard.writeText(text)
            .then(() => {
            })
            .catch((err) => {
            });
    }

    return (
        <div
            className='ticket_scan-modal_wrapper px-3 px-md-0'
        >
            <h3 className='user-ticket_text px-2'>
                My Ticket
            </h3>
            <div className=' ticket_scan-modal position-relative'>
                <div className='ticket-cover_img--container px-4'
                    style={{
                        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.45) 0.09%, rgba(0, 0, 0, 1) 90.97%),
                  url(${coverImg})`
                    }}
                >
                    <div className='qr-code__wrapper '>
                        <div className='qr-code__wrapper__container'>
                            <QRCode value='www.google.com' size={170}/>
                        </div>
                    </div>

                    <div className=' d-flex align-items-center mb-3' >
                        <p className='event-ticket__type px-3  mb-0 me-1'>Public Event</p>
                        <p className='event-ticket__category px-3  mb-0'>Festival</p>


                    </div>
                </div>

                <div className='ticket-details__wrapper px-4'>
                    <h3 className='event-ticket__name'>Music Events</h3>
                    <div className='d-flex mb-4'>
                        <div className='pe-2 ticket-icon__type'>
                            <img src={location} />
                        </div>
                        <div>
                            <p className='mb-0 ticket-icon__name pt-1 mb-1'>Location</p>
                            <p className='mb-0 ticket-icon__value'>Jack’s Place, Maryland Lagos</p>

                        </div>

                    </div>

                    <Row className='mb-4'>
                        <Col xs='6'>
                            <div className='d-flex '>
                                <div className='pe-2 ticket-icon__type'>
                                    <img src={time} />
                                </div>
                                <div>
                                    <p className='mb-0 ticket-icon__name pt-1 mb-1'>Time</p>
                                    <p className='mb-0 ticket-icon__value'>11:30pm - 03:00am</p>

                                </div>

                            </div>
                        </Col>
                        <Col xs='6'>
                            <div className='d-flex '>
                                <div className='pe-2 ticket-icon__type'>
                                    <img src={calendar} />
                                </div>
                                <div>
                                    <p className='mb-0 ticket-icon__name pt-1 mb-1'>Date</p>
                                    <p className='mb-0 ticket-icon__value'>23.Nov.2022</p>

                                </div>

                            </div>
                        </Col>



                    </Row>

                    <Row className='mb-4'>
                        <Col xs='6'>
                            <div className='d-flex '>
                                <div className='pe-2 ticket-icon__type'>
                                    <img src={user} />
                                </div>
                                <div>
                                    <p className='mb-0 ticket-icon__name pt-1 mb-1'>Name</p>
                                    <p className='mb-0 ticket-icon__value'>Franklin Ejindu</p>

                                </div>

                            </div>
                        </Col>

                        <Col xs='6'>
                            <div className='d-flex '>
                                <div className='pe-2 ticket-icon__type'>
                                    <img src={order} />
                                </div>
                                <div>
                                    <p className='mb-0 ticket-icon__name pt-1 mb-1'>Order ID</p>
                                    <p className='mb-0 ticket-icon__value'>Tick-rni3449ni <span className='ps-2' onClick={() => {
                                        copyToClipboard('Tick-rni3449ni')
                                    }}><img src={copy} /></span></p>

                                </div>

                            </div>
                        </Col>



                    </Row>
                </div>
                <div className='ticket-border__line_wrapper px-4'>
                    <div className=' ticket-border__line'>
                    </div>
                </div>

                <div className='ticket-pricing_wrapper px-4 pb-4 text-center pt-4'>
                    <div className='mb-3'>
                        <p className='mb-0 text-center ticket-pricing'><span className='pe-2' ><img src={tag} /></span>Ticket: Early Birds</p>
                    </div>
                    <div>
                        <h3 className='ticket-pricing_value'>
                            <span className='ticket_price_symbol pe-2'>
                                ₦
                            </span>
                            10,000
                        </h3>
                    </div>
                </div>

                <div className='ticket-card_disc left position-absolute'>

                </div>
                <div className='ticket-card_disc right position-absolute'>


                </div>

            </div>

        </div>
    )
}

export default TicketDate